module.exports = __webpack_public_path__ + "static/media/m1cr44.e137fbc9.png";